import { Table, Box, Avatar, Typography, InputLabel } from "@mui/material";
import React from "react";
import { StyledTableCell, StyledTableRow } from "../../Common/StyledCell";
import EmptyData from "../../Common/EmptyData";

const Categories = ({ data }) => {
  console.log(data);
  return (
    <>
      <Table>
        {!data || data?.length === 0 ? (
          <>
            <EmptyData label="No Data available currently" height="400px" />
          </>
        ) : (
          <>
            {data?.map((item, index) => (
              <StyledTableRow key={index}>
                <StyledTableCell>
                  <Box
                    sx={{ display: "flex", alignItems: "center", columnGap: 2 }}
                  >
                    <Box>
                      <InputLabel
                        sx={{
                          fontFamily: "Lato",
                          fontWeight: 500,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {" "}
                        {item?.category?.name}
                      </InputLabel>
                    </Box>
                  </Box>
                </StyledTableCell>
                <StyledTableCell align="right">
                  {item?.totalSold} sold
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </>
        )}
      </Table>
    </>
  );
};

export default Categories;
